<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 contractPropertyTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="properties"
                        arrows >
                    <template slot="gofixTab:properties">
                        <div class="equipment row-split">
                            <b-row>
                                <b-col md="3">
                                    <gofix-card title="property" class="contractTree contractPropertyAria" v-bind:class="{'run-loading':isLoading}">
                                        <template slot="gofixCard:right_header">
                                            <div class="d-flex justify-content-end align-items-center">
                                                <b-button class="mr-3" :disabled="contractActivated || !$checkRole($accessModule.properties, 'delete')" @click="showModalDelNode" title="Delete" v-b-tooltip.hover>
                                                    <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                                    </svg>
                                                </b-button>
                                                <b-button class="mr-3" :disabled="isCheck || !$checkRole($accessModule.properties, 'create')" @click="addChildNode" title="Create" v-b-tooltip.hover>
                                                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                                    </svg>
                                                </b-button>
                                                <b-dropdown :disabled="!$checkRole($accessModule.properties,'create')" class="btn" right v-b-tooltip.hover title="Setting">
                                                    <b-dropdown-item href="javascript:void(0)" @click="modals.import.open = true">Import</b-dropdown-item>
                                                    <!-- <b-dropdown-item href="#">Export</b-dropdown-item> -->
                                                </b-dropdown>
                                            </div>
                                        </template>
                                        <div class="contenAbsolute">
                                            <div class="tree-view-properties">
                                                <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select">
                                                    <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                                                </tree>
                                            </div>
                                        </div>
                                    </gofix-card>
                                </b-col>
                                <b-col md="9" class="pl-md-0">
                                    <gofix-tab :data="tabDataChild" :variableWidth="true" class="contractPropertyChildTab contractSorTab" showFullTab>
                                        <template slot="gofixTab:general_info">
                                            <!-- Form -->
                                            <property-form :value="nodeDataProp" :isRoot="isRoot" @loadReferences="setDataSelect" @saveSuccess="saveSuccessProperty" @refreshData="refreshNodeProperty"></property-form>
                                            <!-- List -->
                                            <property-list :propertyId="selectedNodeId" :reference="reference" ref="propertyList"></property-list>
                                        </template>
                                        <template slot="gofixTab:inventory">
                                            <PropertyInventory
                                                :selectPropertyCategoryOptions="reference.category_name"
                                                :selectLocationTypesOptions="reference.location_type_name"
                                                :inventorySetOptions="this.inventorySetOptions"
                                                :type = "this.type"
                                                :property_id="this.selectedNodeId"
                                                :location_type_id="this.location_type && this.location_type.id"
                                                :room_category_id="this.property_category && this.property_category.id">
                                            </PropertyInventory>
                                        </template>
                                        <template slot="gofixTab:user_defined_fields">
                                            <UserDefinedFields :property_id="this.selectedNodeId" :rootId="this.rootId"></UserDefinedFields>
                                        </template>
                                    </gofix-tab>
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <!-- Modal: Remove Node -->
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.delete.open">
            <div class="center">Are you sure you want to <br/>delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.delete.open = false">No</b-button>
                <b-button class="custom-btn" :disabled="modals.delete.loading" @click="removeNode"> <b-spinner v-if="modals.delete.loading" small type="grow"></b-spinner> Yes</b-button>
            </b-button-group>
        </b-modal>
        <!-- Import File -->
        <modal-import v-model="modals.import.open" @upload="uploadFileImport"/>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import tabData from '@/data/_tabs';
    import LiquorTree from 'liquor-tree'
    import splitPane from 'vue-splitpane'
    const PropertyInventory = () => import('./c-property-inventory')
    const propertyForm = () => import('./c-main/property-form')
    const propertyList = () => import('./c-main/property-list')
    const UserDefinedFields = () => import('./c-property-user-defined-fields')

    export default {
        name: 'c-property',
        components: {
            [LiquorTree.name]: LiquorTree,
            splitPane,
            PropertyInventory,
            propertyForm,
            propertyList,
            UserDefinedFields
        },
        data() {
            return {
                contract_tab:tabData.client_contract,
                tabDataChild:[
                    {
                        key: "general_info",
                        title: "GENERAL INFO",
                        active: true
                    },
                    {
                        key: "inventory",
                        title: "INVENTORY",
                        active: false
                    },
                ],
                modals:{
                    import:{
                        open: false
                    },
                    delete: {
                        open: false,
                        timer: null,
                        loading: false
                    }
                },
                contractActivated: false,
                inventorySetOptions: [],
                type: 'Cluster',
                treeData: this.getData(),
                opts: {
                    minFetchDelay: 500,
                    fetchData: (node) => {
                        node.isBatch = false;
                        if(node.data.id == this.rootId) {
                            return new Promise((resolve, reject) => {
                                resolve([]);
                            });
                        }
                        return new Promise((resolve, reject) => {
                            global.axios(`api/contracts/${this.$route.params.id}/tree-properties/${node.data.id}`, {
                                method: "GET",
                                data: {},
                                headers: {
                                    Accept: "application/json",
                                }
                            })
                                .then(response => {
                                    resolve(response.data.data);
                                })
                                .catch(error => reject(error));
                        });
                    }
                },
                nodeId: '',
                nodeSelected: {},
                nodeDataProp: {},
                selectedNodeId: 0,
                isRoot: true,
                rootId: null,
                nodeParent: null,
                nodeParentModal: null,
                isCheck: false,
                isLoading: true,
                location_type: null,
                property_category: null,
                reference: {
                    category_name:      [],
                    location_type_name: [],
                    property_type_name: []
                },
            }
        },
        mounted() {
            if(this.$refs.tree) {
                this.$refs.tree.$on('tree:mounted', (data) => {
                    this.$nextTick(() => {
                        let nodeRoot = this.$refs.tree.find({
                            data: {
                                id: this.rootId
                            }
                        })

                        this.select(nodeRoot[0]);
                    })
                })
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        watch: {
            ClientContractID: function(val, old) {
                if (!val) {
                    return this.$router.push('/v2/contract-client')
                }
                if(val && old && val.id && old.id && val.id != old.id) {
                    this.type = 'Cluster'
                    this.refreshProperty();
                    this.selectedNodeId = null
                }
            },
        },
        created() {},
        methods: {
            setDataSelect(data) {
                if(this.reference[data.key]) {
                    this.reference[data.key] = data.items;
                }
            },
            saveSuccessProperty(node_data, key = 'adding') {
                this.nodeSelected.data = node_data;

                let dataDrop = JSON.parse(JSON.stringify(this.nodeDataProp))
                dataDrop.data = { ...dataDrop.data, ...node_data }
                this.nodeDataProp = dataDrop
                
                let nodeParent = this.$refs.tree.find({
                    data: {
                        id: node_data.parent_id
                    }
                });

                if (this.nodeParentModal != node_data.parent_id && nodeParent) {
                    const nodeOld = this.nodeSelected;
                    this.nodeSelected.unselect();
                    this.nodeSelected.remove();
                    if (nodeParent && nodeParent[0]) {
                        if(!nodeParent[0].isBatch || nodeParent[0].expanded()) {
                            nodeParent[0].append(nodeOld);
                            nodeParent[0].data.isBatch = true;
                        }
                            
                        if(key == 'editing') {
                            this.nodeParentModal = nodeParent[0].data.id;
                            this.nodeParent      = nodeParent[0].data.id;
                            nodeParent[0].expand();
                            nodeParent[0].select();
                            this.nodeSelected = nodeParent[0];
                            this.select(nodeParent[0])
                        }
                    }
                }

                if(key == 'adding') {
                    this.isCheck = false;
                    this.nodeSelected.unselect();
                    if (nodeParent) {
                        let node = this.$refs.tree.selected();
                        node.unselect();
                        nodeParent[0].data.isBatch = true;
                        nodeParent.select(true)
                        this.nodeSelected = nodeParent[0];
                        this.select(nodeParent[0]);
                        this.nodeSelected.expand();
                    } else
                        this.nodeSelected = null;
                }
                this.$refs.propertyList.$refs.gofixTable.reloadTableKeepFilter();
            },
            getInventorySetOptions(){
                this.$store.dispatch("PropertyController/getInventorySetOptions", {property_id: this.selectedNodeId})
                    .then(response => {
                        this.inventorySetOptions = response.data.data.items;
                    })
            },
            /*--- Property ---*/
            getData() {
                return new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${this.$route.params.id}/tree-properties/0`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    }).then(response => {
                        response.data.data[0].state.selected = true;
                        this.rootId = response.data.data[0].data.id;
                        this.isLoading = false;
                        resolve(response.data.data);
                    })
                    .catch(error => reject(error));
                });
            },
            refreshProperty() {
                this.isLoading = true;
                global.axios(`api/contracts/${this.$route.params.id}/tree-properties/0`, {
                    method: "GET",
                    data: {},
                    headers: {
                        Accept: "application/json",
                    }
                }).then(response => {
                    this.isLoading = false;
                    response.data.data[0].state.selected = true;
                    this.rootId = response.data.data[0].data.id;
                    this.nodeSelected = null
                    this.isRoot = true
                    this.isCheck = false;
                    this.name = ''
                    this.$refs.tree.tree.setModel(response.data.data);
                    let nodeRoot = this.$refs.tree.find({
                    data: {
                        id: this.rootId
                      }
                    })
                    this.nodeSelected = nodeRoot[0];
                    this.select(nodeRoot[0]);
                })
                .catch(error => {
                    this.isLoading = false;
                });
            },
            /*--- Select Node ---*/
            async select(node) {
                if(!this.$checkRole(this.$accessModule.properties,"read",node.data.lft)) {
                    node.unselect();
                    this.nodeSelected = null;
                    return;
                }
                
                if(!node.selected())
                    node.select();

                if (node.data.id) {
                    let PropertyInfo = await global.axios(`api/contracts/${this.$route.params.id}/properties/${node.data.id}`, {
                            method: "GET",
                            headers: {
                                Accept: "application/json",
                            }
                        });

                    delete PropertyInfo.data.data.children;
                    node.data = PropertyInfo.data.data;
                }

                this.nodeParent         = node.data.parent_id;
                this.nodeParentModal    = node.data.parent_id;
                this.nodeSelected       = node;
                this.nodeDataProp       = JSON.parse(JSON.stringify(node));
                this.nodeDataProp.parent = JSON.parse(JSON.stringify(node.parent));
                this.selectedNodeId     = node.data.id;
                this.location_type      = node.data.location_type;
                this.property_category  = node.data.category;
                this.type               = node.data.type;

                node.data.id == this.rootId ? this.isRoot = true : this.isRoot = false
                this.contractActivated = false;
                if(node.data.id == this.rootId && this.ClientContractID.status == 'Active'){
                    this.contractActivated = true;
                }
            
                this.getInventorySetOptions();
                if(this.$refs.gofixTable){
                    this.$refs.gofixTable.reloadTableKeepFilter();
                }

                /* add/remove tab user_defined_fields */
                let keyExists = this.tabDataChild.find(obj => obj.key == "user_defined_fields" );
                if(node.data.parent_id) {
                    if(!keyExists) {
                        this.tabDataChild.push({
                            key: "user_defined_fields",
                            title: "USER DEFINED FIELDS",
                            active: false
                        });
                    } 
                }else{
                    this.$delete(this.tabDataChild, 2);
                }
                
            },
            async refreshNodeProperty() {
                if(this.nodeDataProp.data && this.nodeDataProp.data.id) {
                    let PropertyInfo = await global.axios(`api/contracts/${this.$route.params.id}/properties/${this.nodeDataProp.data.id}`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    });

                    delete PropertyInfo.data.data.children;
                    let node  = JSON.parse(JSON.stringify(this.nodeDataProp));
                    node.data = PropertyInfo.data.data;
                    this.nodeDataProp = node;
                }
            },
            /*--- Add Node ---*/
            addChildNode() {
                if(!this.$checkRole(this.$accessModule.properties, 'create') || !this.nodeSelected) 
                    return;
                
                let type = '';
                let type_parent = this.nodeSelected.data.type;
                if (type_parent == 'Cluster' || type_parent == 'Root') {
                    type = 'Cluster'
                }
                if (type_parent == 'Building' || type_parent == 'Location') {
                    type = 'Location'
                }
                if (this.nodeSelected.enabled()) {
                    this.nodeSelected.states.expanded = true;
                    this.nodeSelected.states.selected = false;
                    var nodeNew = this.nodeSelected.append({
                        data: {
                            parent_id: this.nodeSelected.data.id,
                            type: type,
                            status: false,
                            name: 'New node',
                        },
                        text: 'New node',
                        state: {
                            selected: true,
                            enabled: true
                        }
                    });
                    this.type            = type;
                    this.nodeParent      = this.nodeSelected.data.id;
                    this.nodeParentModal = this.nodeSelected.data.id;
                    this.nodeSelected    = nodeNew;
                    this.select(this.nodeSelected);

                    // Fix disabled button, don't hide tooltips
                    this.$root.$emit('bv::hide::tooltip');

                    this.isCheck = true;
                    this.nodeId = nodeNew.id;
                    this.isRoot = false;
                }
            },
            /*--- Remove Node ---*/
            showModalDelNode() {
                if (!this.nodeSelected) {
                    return this.$alertNotification("Please select property", "warning");
                }

                this.modals.delete.open = true;
            },
            removeNode() {
                if (this.modals.delete.timer) {
                    clearTimeout(this.modals.delete.timer);
                    this.modals.delete.timer = null;
                }
                this.modals.delete.timer = setTimeout(() => {
                    if(!this.$checkRole(this.$accessModule.properties, 'delete')) return;
                    if (this.nodeSelected) {
                        if (this.nodeSelected.id == this.nodeId) this.isCheck = false;
                        if (this.nodeSelected.data.status != false) {
                            this.modals.delete.loading = true;
                            this.$store.dispatch('PropertyController/removeProperty', {
                                id: this.nodeSelected.data.id,
                                contract_id: this.$route.params.id
                            }).then(response => {
                                if (this.nodeSelected && this.nodeSelected.data.id == this.rootId) this.refreshProperty();
                                this.modals.delete.open = false;
                                this.modals.delete.loading = false;
                            }).catch(err => {
                                this.modals.delete.open = false;
                                this.modals.delete.loading = false;
                            })
                        }
                        
                        this.modals.delete.open = false;
                        this.$alertNotification(this.$notificationV2('deleting', 'property'));

                        let nodeParent = this.$refs.tree.find({
                            data: {
                                id: this.nodeSelected.data.parent_id
                            }
                        })

                        if (nodeParent[0].children && nodeParent[0].children.length == 0) {
                            nodeParent[0].data.isBatch = false;
                        }

                        if (this.nodeSelected.data.id == this.nodeId) {

                            this.nodeSelected.children = [];

                            this.nodeSelected.unselect();

                        } else {
                            this.nodeSelected.remove();
                        }

                        this.nodeParent = null;
                        this.select(nodeParent[0]);
                    }
                }, 100);
            },
            /*--- Import ---*/
            async uploadFileImport(callback){
                const { file, resolve, reject } = await callback();
                this.$store.dispatch(`PropertyController/uploadFileImport`, {
                    contract_id: this.$route.params.id,
                    fileImport:  file
                })
                .then(response => {
                    this.refreshProperty();
                    resolve({
                        result: response.data.data,
                        msg_success: this.$notificationV2('importing', 'property')
                    });
                })
                .catch(err => {
                    reject(err);
                })
            },
        }
    }
</script>
